/**
 * Founder Control Center v2 · Sección 5 · AI Agents.
 *
 * Reutiliza el AgentCenter existente. No se crean agentes nuevos en esta fase.
 * La sección está PREPARADA para que en Sprint A los 7 agentes (AG-01..AG-07)
 * puedan ejecutar autónoma o manualmente.
 *
 * 0% código nuevo de negocio. Solo wrapper que delega.
 */
import { Robot } from "@phosphor-icons/react";
import AgentCenter from "../AgentCenter";

export default function AgentsSection() {
  return (
    <div data-testid="fcc-agents-section">
      {/* Banner informativo · AG-07 ACTIVO · resto preparado */}
      <div className="mx-4 sm:mx-6 lg:mx-8 mt-6 rounded-sm border border-emerald-500/30 bg-emerald-500/5 px-4 py-3 text-xs text-[var(--ag-text-dim)]" data-testid="fcc-agents-banner">
        <div className="flex items-start gap-2">
          <Robot size={14} weight="fill" className="text-emerald-400 mt-0.5 shrink-0" />
          <div>
            <strong className="text-emerald-400">AG-07 Founder Copilot ACTIVO.</strong>
            {" "}Disponible en{" "}
            <a href="/founder/intelligence?sub=copilot" className="underline hover:text-emerald-300">Intelligence → Founder Copilot</a>
            {" "}con RAG real sobre 17+ docs estratégicos + tool calling read-only.
            Los agentes AG-01..AG-06 siguen <em>planned</em>; se activan en el resto del Sprint A.
          </div>
        </div>
      </div>
      <AgentCenter />
    </div>
  );
}
